export enum Currencies {
  TRY = 'TRY',
  USD = 'USD',
}

export enum CurrencySymbols {
  TRY = "₺",
  USD = "$"
}
